export default "__VITE_ASSET__c0a13864__"